export default "__VITE_ASSET__4YZQaARB__"